import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

import { FormIdMappings } from '@src/constants';
import { SuccessCard } from '@src/lib/__generated/contentful/sdk';

type State = {
	restUrl: string;
	googleUrl: string;
	smartyEmbeddedKey: string;
	userEventsUrl: string;
	successCards: SuccessCard[];
	leadFormId: string;
  languageToggleEnabled: boolean;
};

type Actions = {
	setRestUrl: (url: string) => void;
	setGoogleUrl: (url: string) => void;
	setSmartyEmbeddedKey: (smartyEmbeddedKey: string) => void;
	setUserEventsUrl: (url: string) => void;
	setSuccessCards: (successCards: SuccessCard[]) => void;
	setLeadFormId: (leadFormId: string) => void;
  setLanguageToggleEnabled: (enabled: boolean) => void;
};

const useAppStore = create<State & Actions>((set) => ({
	restUrl: 'https://wwwstg.clearchoice.com/api/v1/cc/', // default to stage
	googleUrl: 'https://www.google.com/maps/conversion/debug/collect', // default to stage

	setRestUrl: (url) => set({ restUrl: url }),
	setGoogleUrl: (url) => set({ restUrl: url }),
	smartyEmbeddedKey: '',
	setSmartyEmbeddedKey: (smartyEmbeddedKey) => set({ smartyEmbeddedKey }),
	userEventsUrl: 'https://userevents.dataplatform.gke.us-central1.gcp.stage.aspendental.com/', // default to stage
	setUserEventsUrl: (userEventsUrl) => set({ userEventsUrl }),
	successCards: [],
	setSuccessCards: (successCards) => set({ successCards }),
	leadFormId: FormIdMappings.formID,
	setLeadFormId: (leadFormId) => set({ leadFormId }),
  setLanguageToggleEnabled: (languageToggleEnabled) => set({ languageToggleEnabled }),
  languageToggleEnabled: true,
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('appStore', useAppStore);
}

export default useAppStore;
